const routes = [
    {
        path: "/program-module",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
